import {
  ITextFieldVariant,
  IButtonVariant,
  IPaperVariant,
  IFCDashboardIconSize,
  IFCDrawerIconSize,
} from '../types/frontend/utils'

export const TEXTFIELD_VARIANT_STANDARD: ITextFieldVariant = 'standard'
export const TEXTFIELD_VARIANT_OUTLINED: ITextFieldVariant = 'outlined'
export const TEXTFIELD_VARIANT_FILLED: ITextFieldVariant = 'filled'

export const BUTTON_VARIANT_TEXT: IButtonVariant = 'text'
export const BUTTON_VARIANT_CONTAINED: IButtonVariant = 'contained'
export const BUTTON_VARIANT_OUTLINED: IButtonVariant = 'outlined'

export const PAPER_VARIANT_ELEVATION: IPaperVariant = 'elevation'
export const PAPER_VARIANT_OUTLINED: IPaperVariant = 'outlined'

export const FC_DASHBOARD_ICON_SIZE: IFCDashboardIconSize = '3.2rem'
export const FC_BUTTON_ICON_SIZE: IFCDashboardIconSize = '2rem'
export const FC_DRAWER_ICON_SIZE: IFCDrawerIconSize = '1.3rem'
export const FC_TREE_ICON_SIZE: IFCDrawerIconSize = '1.5rem'